import Vue from "vue";
import Vuex from "vuex";
import getModule from "./modules/getModule.js";
import postModule from "./modules/postModule.js";
import authModule from "./modules/authModule.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    getModule,
    postModule,
    authModule
  }
});

